import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ISideNavigationConfig } from '@shared/modules/side-navigation/interfaces/side-navigation-config.interface';
import { ISideNavigationTab } from '@shared/modules/side-navigation/interfaces/side-navigation-tab.interface';
import { SideNavigationBaseMenuComponent } from '@shared/modules/side-navigation/components/side-navigation-base-menu/side-navigation-base-menu.component';

@Component({
  selector: 'side-navigation-view',
  templateUrl: './side-navigation-view.component.html',
  styleUrls: ['./side-navigation-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavigationViewComponent implements OnInit {
  private _config: ISideNavigationConfig;
  hiddenSideNavigation: boolean = false;

  @Input() updateLocationParam: boolean;

  @Input()
  set config(config: ISideNavigationConfig) {
    this._config = config;
    this.changes.detectChanges();
  }

  get config() {
    return this._config;
  }

  @ViewChild('sideNavigationBaseMenuComponent')
  sideNavigationBaseMenuComponent: SideNavigationBaseMenuComponent;
  @Output('onTabClick') onTabClick: EventEmitter<ISideNavigationTab> = new EventEmitter<ISideNavigationTab>();
  @Output('onBackClick') onBackClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('onHiddenSideNavigation') onHiddenSideNavigation: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  constructor(public changes: ChangeDetectorRef) {}

  ngOnInit(): void {}
}
